module.exports = __webpack_public_path__ + "img/failed.e9e71749.svg";